// Copyright (c) 2026, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { AppBar, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store/rootReducer";
import PageFooterContent from "./PageFooterContent";

const PageFooter: React.FC<{}> = () => {
  const isDarkTheme = useSelector((state: RootState) => state.theme);
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      sx={{
        top: "auto",
        bottom: 0,
        height: "18px",
        backgroundImage: "none",
        backgroundColor: isDarkTheme
          ? theme.palette.secondary.main
          : theme.palette.primary.contrastText,
      }}
    >
      <PageFooterContent />
    </AppBar>
  );
};

export default PageFooter;
